// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { WARN_MULTIPLE_TAGS, } from "../../../app/localStorageKeys"

export type StorageWriter = (value: boolean) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(WARN_MULTIPLE_TAGS, value.toString())
}

export const persistWarnMultipleTags = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setWarnMultipleTags.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.warnMultipleTagsPersisted()),
        catchError(_ => of(Actions.warnMultipleTagsPersistFailed())),
      )),
    )

export default persistWarnMultipleTags(persist)

